export default __webpack_public_path__ + "static/Anmeldung-0cb4e9c33660ed45cf27d9ea4bb2de17.pdf";